import { WarningRounded as WarningRoundedIcon } from '@mui/icons-material'
import {
  Box,
  Link,
  Pagination,
  PaginationItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material'
import { t } from 'i18next'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'

import { useGlobalContext } from '../../Shared/Contexts/GlobalContext.jsx'
import EventDuration from '../EventDuration/EventDuration.jsx'

const EventsTable = ({ events, onPageChange, paging }) => {
  const navigate = useNavigate()
  const { language } = useGlobalContext()
  moment.locale(language)

  const { page, pageSize } = paging

  const handleChangePage = (_, value) => onPageChange(value)

  const handleClickDevice = (device) => navigate(`/detail/${device.id}?returnTo=eventsList`)

  return (
    <>
      <TableContainer component={Box}>
        <Table aria-label="events table" data-testid="events table">
          <TableHead>
            <TableRow>
              <TableCell component="th">In allarme</TableCell>
              <TableCell component="th">{t('common.startedAt')}</TableCell>
              <TableCell component="th">{t('common.endedAt')}</TableCell>
              <TableCell component="th">{t('common.device')}</TableCell>
              <TableCell component="th">{t('common.ruleType')}</TableCell>
              <TableCell component="th">{t('triggers.triggerName')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {events?.data.map((row) => (
              <TableRow
                key={row.id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell>
                  {row.isAlarm && !row.endedAt && (
                    <WarningRoundedIcon
                      size={16}
                      color="red"
                    />
                  )}
                  {row.isAlarm && row.endedAt && (
                    <WarningRoundedIcon
                      size={16}
                      color="grey"
                    />
                  )}
                </TableCell>
                <TableCell>
                  <Typography variant="p">
                    {moment(row.startedAt).format('DD/MM/YY HH:mm:ss')}
                  </Typography>
                  <Typography variant="body2">
                    <small>{moment(row.startedAt).fromNow()}</small>
                  </Typography>
                </TableCell>
                <TableCell>
                  {row.endedAt && (
                    <>
                      <Typography variant="p">
                        {moment(row.endedAt).format('DD/MM/YY HH:mm:ss')}
                      </Typography>

                      <EventDuration
                        start={row.startedAt}
                        end={row.endedAt}
                      />
                    </>
                  )}
                </TableCell>
                <TableCell>
                  <Typography variant="body2">
                    {row.device.brand.name}/{row.device.model.name}
                  </Typography>
                  {row.device.name != null ?
                    <Box>
                      <Link
                        variant="subtitle2"
                        href="#"
                        underline="hover"
                        onClick={() => handleClickDevice(row.device)}
                      >
                        <b>{row.device.name}</b>
                      </Link>
                    </Box> : null
                  }
                  <Typography variant="standard"
                    sx={{ fontWeight: 'bold' }}>
                    {row.device?.organizationKey}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    id="organization-key-event"
                    variant="p"
                  >
                    {row.rule?.name}</Typography>
                  <Typography
                    id="rule-type-event"
                    variant="body2">
                    {row.type}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    id="trigger-name-event"
                    variant="body2">
                    {row.trigger?.name}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {events && (
        <Box
          display="flex"
          justifyContent="center"
        >
          <Pagination
            count={Math.ceil(events?.count / pageSize)}
            page={page}
            onChange={handleChangePage}
            renderItem={(item) => {
              const ariaLabels = {
                first: t('pagination.firstPage'),
                last: t('pagination.lastPage'),
                next: t('pagination.nextPage'),
                previous: t('pagination.previousPage'),
                page: t('pagination.goToPage', { page: item.page })
              }

              return (
                <PaginationItem
                  {...item}
                  aria-label={ariaLabels[item.type]}
                  data-testid={`pagination-${item.type}${item.type === 'page' ? `-${item.page}` : ''}`}
                />
              )
            }}
            showFirstButton
            showLastButton
          />
        </Box>
      )}
    </>
  )
}

export default EventsTable
